import ListProducers from "@/views/agro_exporter/providers/producers/ListProducers.vue";
import ShowProducer from "@/views/agro_exporter/providers/producers/ShowProducer.vue";
import NewProducer from "@/views/agro_exporter/providers/producers/NewProducer.vue";
import EditProducer from "@/views/agro_exporter/providers/producers/EditProducer.vue";
import NewCropField from "@/views/agro_exporter/providers/producers/NewCropField.vue";
import EditCropField from "@/views/agro_exporter/providers/producers/EditCropField.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ae",
  role: "providers",
  permission: "producers"
});

export default [
  {
    path: "/ae/:agro_exporter_id/providers/producers/list_producers",
    name: routeName(""),
    redirect: { name: routeName("list_producers") }
  },
  {
    path: "/ae/:agro_exporter_id/providers/producers/list_producers",
    name: routeName("list_producers"),
    component: ListProducers,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/providers/producers/show_producer/:producer_id",
    name: routeName("show_producer"),
    component: ShowProducer,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/providers/producers/new_producer",
    name: routeName("new_producer"),
    component: NewProducer,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/providers/producers/edit_producer/:producer_id",
    name: routeName("edit_producer"),
    component: EditProducer,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/providers/producers/new_crop_field/:producer_id",
    name: routeName("new_crop_field"),
    component: NewCropField,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/providers/producers/edit_crop_field/:producer_id/:crop_field_id",
    name: routeName("edit_crop_field"),
    component: EditCropField,
    props: true,
    meta: META
  }
]
